module.exports = __webpack_public_path__ + "f28a9b205f84be619202c4f7cc763a4d.MP3";